<ion-header>
    <ion-toolbar>
        <ion-title>{{ "new_size_guide_modal_title" | translate }}</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="dismiss()">{{ "Cancel" | translate }}</ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content>
    <div class="position-relative min-height-modal">
        <div class="sg-modal-loading d-flex justify-content-center py-5" *ngIf="catalogLoading">
            <app-loader></app-loader>
        </div>
        <app-size-guide-editor-form [existingGuide]="existingGuide" (loadingChange)="catalogLoading = $event"></app-size-guide-editor-form>
    </div>
</ion-content>
<ion-footer>
    <ion-toolbar>
        <ion-buttons slot="end" class="ion-padding-end">
            <ion-button fill="clear" (click)="dismiss()">{{ "Cancel" | translate }}</ion-button>
            <ion-button (click)="save()">{{ "Save" | translate }}</ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-footer>
